import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import {
  CopyFeedButton,
  MEET_CALENDAR,
  SubscribeLink,
} from '../Calendar/Calendar';

// The listing block's "Link more" field
const MoreLink = ({ linkTitle, linkHref, isEditMode }) => {
  const href = linkHref?.[0]?.['@id'];
  if (!href) return null;
  // Pointing the link at the meet calendar feed makes it a subscribe link
  if (flattenToAppURL(href) === MEET_CALENDAR) {
    return (
      <div className="asaj-more asaj-more-cal">
        <SubscribeLink>
          {linkTitle || 'Subscribe to the meet calendar'}
          <span aria-hidden="true">→</span>
        </SubscribeLink>
        <CopyFeedButton className="asaj-copy" />
      </div>
    );
  }
  return (
    <div className="asaj-more">
      <ConditionalLink
        to={isInternalURL(href) ? flattenToAppURL(href) : href}
        condition={!isEditMode}
      >
        {linkTitle || href}
        <span aria-hidden="true">→</span>
      </ConditionalLink>
    </div>
  );
};

export default MoreLink;
